import { Link } from "react-router-dom";

const A = "/brand";
const btnGhostTeal =
  "inline-flex items-center justify-center gap-2 border border-[#159E9A]/60 text-[#159E9A] rounded-[10px] px-6 py-3 text-sm font-medium hover:bg-[#159E9A] hover:text-white transition-colors";

const cols = [
  {
    eyebrow: "✨ Start Here",
    title: "Vision Book Workshop",
    img: `${A}/blueprint4joy-home-vision-book-workshop.jpg`,
    alt: "Lara creating a vision book surrounded by magazine clippings and inspiration images.",
    button: "Explore the Workshop",
    link: "/work-with-me/vision-book-workshop",
  },
  {
    eyebrow: "🌿 Go Deeper",
    title: "10-Week Group Experience",
    img: null,
    button: "Learn More",
    link: "/believing-happy",
  },
  {
    eyebrow: "🎤 Bring Blueprint4Joy® to Your Audience",
    title: "Speaking & Keynotes",
    img: null,
    button: "Explore Speaking",
    link: "/speaking",
  },
];

export function WaysToWork() {
  return (
    <section data-testid="ways-section" className="relative overflow-hidden bg-[#FAFAF8]">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 pt-6 md:pt-8 pb-12 md:pb-14">
        <div className="max-w-3xl mb-12 reveal">
          <h2 className="font-display text-4xl md:text-5xl lg:text-6xl leading-[1.08] tracking-tight text-[#1C1917]">
            Ways to Work Together
          </h2>
        </div>

        <article className="reveal mb-16 md:mb-20">
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-0 items-center">
            <div className="lg:col-span-6 relative">
              <div className="relative aspect-[4/3] lg:aspect-[3/2]">
                <img
                  src={cols[0].img}
                  alt={cols[0].alt}
                  loading="lazy"
                  className="w-full h-full object-cover"
                />
                <div
                  className="absolute inset-y-0 right-0 w-48 lg:w-64"
                  style={{
                    background:
                      "linear-gradient(to right, rgba(250,250,248,0) 0%, rgba(250,250,248,0.7) 50%, #FAFAF8 100%)",
                  }}
                />
              </div>
            </div>
            <div className="lg:col-span-6 lg:pl-2 xl:pl-4 pt-8 lg:pt-0">
              <p className="text-[11px] tracking-[0.28em] uppercase text-[#F6A041] mb-4 font-medium">
                {cols[0].eyebrow}
              </p>
              <h3 className="font-display text-3xl md:text-4xl lg:text-5xl leading-[1.1] text-[#1C1917] mb-4">
                {cols[0].title}
              </h3>
              <p className="text-base md:text-lg text-[#57534E] leading-relaxed mb-6 max-w-xl">
                A guided experience to reconnect with what matters, clarify what comes next, and begin bringing it to life.
              </p>
              <Link to={cols[0].link} data-testid="way-0-cta" className={btnGhostTeal}>
                {cols[0].button}
              </Link>
            </div>
          </div>
        </article>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-10 md:gap-12">
          {cols.slice(1).map((c, i) => (
            <article key={i + 1} data-testid={`way-${i + 1}`} className="reveal">
              <p className="text-[11px] tracking-[0.28em] uppercase text-[#F6A041] mb-4 font-medium">
                {c.eyebrow}
              </p>
              <h3 className="font-display text-2xl md:text-3xl lg:text-4xl leading-[1.15] text-[#1C1917] mb-6">
                {c.title}
              </h3>
              <Link to={c.link} data-testid={`way-${i + 1}-cta`} className={btnGhostTeal}>
                {c.button}
              </Link>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
